import { z } from 'zod';

export const cultureAIGenerateSchema = z.object({
  desired_values: z.string().min(5, 'Desired values must be at least 5 characters').optional().or(z.literal('')),
  work_environment: z.string().min(5, 'Work environment must be at least 5 characters').optional().or(z.literal('')),
  team_characteristics: z
    .string()
    .min(5, 'Team characteristics must be at least 5 characters')
    .optional()
    .or(z.literal('')),
  leadership_style: z.string().min(5, 'Leadership style must be at least 5 characters').optional().or(z.literal('')),
});

export type CultureAIGenerateFormData = z.infer<typeof cultureAIGenerateSchema>;
